module.exports = __webpack_public_path__ + "site/img/64.7abb252e.jpg";